import { type FC, useId } from "react";

type Props = {
  level: number;
  className?: string;
};

const LevelGlyph: FC<Props> = ({ level, className }) => {
  const id = useId();

  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <text x="4" y="27" fontSize="32" fontWeight="600" fill={`url(#${id})`}>
        {level}
      </text>
      <path
        transform="translate(19.83 4.8)"
        d="M0 8V0H1.30551V8H0ZM4.19713 8L2.28371 2.68478H3.67892L4.80504 6.25H4.81501L5.96107 2.68478H7.32638L5.41296 8H4.19713ZM8.19449 8V0H9.5V8H8.19449Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient
          id={id}
          x1="0"
          y1="0"
          x2="0"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LevelGlyph;
